import React from 'react'
import styles from './style.module.css'
import '../carousel.css'
import propertyOwnerImg from './Assets/home_2_1.webp'
import evDriverImg from './Assets/home_2_2.webp'
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Carousel from 'react-bootstrap/Carousel';
import BulletList from '../../components/BulletList'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import { Link } from 'react-router-dom'
import SubHeading from '../../components/SubHeading'


const Home_2 = () => {

    const sliderSettings = {
        dots: true,
        infinite: true,
        // arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const scrollToTop = () => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
    };


    let propertyOwnerCard = (
        <div className={styles['home-2-sub2-inner']}>
            <img src={propertyOwnerImg} alt="EV Driver" className={styles['home-2-sub2-inner-img']} />
            <div className={styles['home-2-sub2-inner-header-container']}>
                <div className={styles['home-2-sub2-inner-header']}>
                    Property Owners
                </div>
                <div className={styles['home-2-sub2-inner-para']}>
                    Transform parking at your property into a profitable amenity 
                    with our reservation-enabled EV charging solutions.
                </div>
            </div>

            <div className={styles['list-items']}>
                <BulletList items={
                    [
                        'Generate monthly revenue',
                        'Minimal upfront investment',
                        '24/7 management and maintenance',
                    ]
                } />
            </div>


            {/* <button className={styles['home-2-sub2-inner-button']}>Partner With Us</button> */}
            <Link className={styles['home-2-sub2-inner-button']} onClick={scrollToTop} to={'/partner-with-us'} style={{width:'auto', margin:'13px 11px 21px 11px'}}>Partner With Us</Link>
        </div>
    );

    let evDriverCard = (
        <div className={styles['home-2-sub2-inner']}>
            <img src={evDriverImg} alt="EV Driver" className={styles['home-2-sub2-inner-img']} />
            <div className={styles['home-2-sub2-inner-header-container']}>
                <div className={styles['home-2-sub2-inner-header']}>
                    EV Drivers
                </div>
                <div className={styles['home-2-sub2-inner-para']}>
                    Say goodbye to charging anxiety. Reserve your charging slot in
                    advance and charge with confidence.
                </div>
            </div>
            <div className={styles['list-items']}>
                <BulletList items={
                    [
                        'Reserve charging slots in advance',
                        'No more waiting or uncertainty',
                        'Simple payment and smart notifications',
                    ]
                } />
            </div>
            {/* <button className={styles['home-2-sub2-inner-button']}>Start Charging</button> */}
            {/* <Button style={{width:'auto', margin:'13px 11px 21px 11px'}}>Start Charging</Button> */}
            <Link target='_blank' className={styles['home-2-sub2-inner-button']} to='https://app.breathe-ev.com/'>Start Charging</Link>

        </div>
    );
    return (

        <div className={`container`}>

            <div className='text-center'>
                <Heading>Choose Your Path</Heading>
                <SubHeading bottomMargin={'20px'}>
                    Whether you're looking to charge your electric vehicle or want to offer EV charging
                    at your property, BreatheEV has the perfect solution for you.
                </SubHeading>
                {/* <div className={styles['home-2-sub1-para']}>
                    Whether you're looking to charge your electric vehicle or want to offer EV charging
                    at your property, BreatheEV has the perfect solution for you.
                </div> */}
            </div>


            <div className={`${styles['mobile-carousel']} mobile-carousel`}>

                <Carousel interval={15000} data-bs-theme="dark" nextIcon prevIcon>

                    <Carousel.Item>
                        <div className={styles['home-2-sub2-container']}>
                            {propertyOwnerCard}
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className={styles['home-2-sub2-container']}>
                            {evDriverCard}
                        </div>
                    </Carousel.Item>

                </Carousel>

            </div>
            <div className={styles['desktop-layout']}>
                <div className={styles['home-2-sub2-container']}>
                    {propertyOwnerCard}
                    {evDriverCard}
                </div>
            </div>


        </div>

    )
}

export default Home_2

